import { Component, OnInit } from "@angular/core";
import dayGridPlugin from '@fullcalendar/daygrid';
import esLocale from '@fullcalendar/core/locales/es';
import interactionPlugin from '@fullcalendar/interaction';
import {NgForm, FormGroup, FormControl, Validators} from '@angular/forms';
import { AppointmentsService } from 'src/app/services/appointments.service';
import { DatosService } from '../servicios/datos.service';
import * as moment from 'moment';

@Component({
  selector: "app-appointments",
  templateUrl: "./appointments.component.html",
  styleUrls: ["./appointments.component.scss"]
})
export class AppointmentsComponent implements OnInit {

  public submitted = false;

  appointmentForm = new FormGroup({
    'first_name': new FormControl('', [Validators.required]),
    'surname': new FormControl('', [Validators.required]),
    'phone': new FormControl('', [Validators.required]),
    'email': new FormControl('', [Validators.required]),
    'comment': new FormControl('', [])
  })

  esLocale = esLocale;
  calendarPlugins = [interactionPlugin, dayGridPlugin];
  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};
  currentStep = 0;
  confirmOrderStep = false;
  status: boolean = false;
  columnHeaderFormat = { weekday: 'short' }
  calendarEventConstraint = { daysOfWeek: [ 1, 2, 3, 4, 5, 6 ]}
  calendar_hidden_days = [0]
  calendarHeader = {
    left: 'prev',
    center: 'title',
    right: 'next'
  }
  selectedDate = null;

  get f(){
    return this.appointmentForm.controls;
  }

  onSubmit() {
    this.submitted = true;
    if(this.appointmentForm.valid && this.selectedDate){
      let postData = Object.assign({}, this.appointmentForm.value)
      postData['services'] = this.selectedServices;
      postData['selectedTime'] = this.calendarTime[this.selectedTime];
      postData['selectedDate'] = moment.utc(this.prettySelectedDate(), "D-M-YYYY").toDate();
      this.appointmentsService.createAppointment(postData)
      .then(() => {
        this.confirmOrderStep = true;
      })
    }
    
  }


  public selectedServices = []
  public desplegado = false
  public selectedTime = null;

  public calendarTime = [
    { dia : 'Mañana' , hora : '10:00 - 11:30'},
    { dia : 'Medío dia' , hora : '12:00 - 16:00'},
    { dia : 'Tarde' , hora : '16:30 - 21:00'}
  ]

  constructor( private appointmentsService : AppointmentsService,
    private _dataService: DatosService) {
    
    this.currentStep = 0;
  }

  public services = this._dataService.services

  selectService(service){
    let posicion = this.selectedServices.indexOf(service)
    if( posicion === -1 ){
      this.selectedServices.push(service)
    }else{
      this.selectedServices.splice( posicion , 1)
    }
  }
  desplegarSelect(){
    this.desplegado = !this.desplegado
  }

  handleDateClick(arg) {
    this.selectedDate = arg.start;
  }

  prettySelectedDate() {
    let pretty_date = `${this.selectedDate.getDate()}-`;
    pretty_date += `${this.selectedDate.getMonth() + 1}-`;
    pretty_date += `${this.selectedDate.getFullYear()}`;
    return pretty_date;
  }

  activeSelectTime(inputTime) {
    this.selectedTime = inputTime;
}

  canContinue() {
    if (this.currentStep == 0) 
      return this.selectedServices.length > 0
    else if (this.currentStep == 1)
      return this.selectedTime != null && this.selectedDate != null;
    else if (this.currentStep == 2){
      return !this.appointmentForm.invalid && this.submitAppointmentForm();
    }
    else {
      return false
    }
  }

  submitAppointmentForm(){
    // PUSH Firebase

    this.nextStep()

  }

  nextStep() {
    if (this.currentStep >= 2) return;
    this.currentStep++;
  }

  public printableSelectedItems() {
    return this.selectedServices.map(el => `${el.service}, ${el.price}`);
  }

  previousStep() {
    if (this.currentStep <= 0) return;
    this.currentStep--;
  }
  ngOnInit() {}

}
